export { LoaderQuizScreenV15_0_5 } from './LoaderQuizScreenV15_0_5';
